export default (state = {}, {latestAcceptedPeriodId}: any) => {
  return {
    ...state,
    latestAcceptedPeriodId,
  };
};
